<template>
  <div class="pop">
    <div class="pop-mark">
      <transition name="fade" @after-leave="afterLeave">
        <div v-show="showCountDownTime" class="pop-time-count">{{ countDownTime }}</div>
      </transition>

      <div v-if="showPopDialog" class="pop-dialog">
        <div class="pop-bg">
          <div class="pop-open-packet">
            <div @touchstart="openRedPacket">
              <img src="../../../assets/images/redPacketRain/mobile/open.png"/>
            </div>
            <div>
              <div class="pop-text">
                <strong>易加礼惠 鼠年好运</strong>
                <span>开启新年惊喜红包吧</span>
              </div>
            </div>
          </div>
        </div>

        <div class="pop-btn-close">
          <img @touchstart="handleClosePop" src="../../../assets/images/redPacketRain/mobile/btn-close.png"/>
        </div>
      </div>

      <div v-if="showPrizePop" class="pop-dialog">
        <div class="pop-bg">
          <div class="pop-open-packet">
            <div>
              <img :src="popOpen.imgUrl"/>
            </div>
            <div>
              <div class="pop-text">
                <strong v-html="popOpen.title"></strong>
                <span>{{ popOpen.content }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="pop-btn-close">
          <img @touchstart="handlePrizePop" src="../../../assets/images/redPacketRain/mobile/btn-close.png"/>
        </div>
      </div>

      <canvas id="canvas"></canvas>
    </div>
  </div>
</template>

<script>
import activityApi from '@/api/activity'

export default {
  name: 'RedPacketPop',
  props: {
    activityTimeList: {
      type: Array,
      default: () => {
        return []
      }
    },
    currentActivityStartTime: {
      type: Number,
      default: null
    },
    currentActivityEndTime: {
      type: Number,
      default: null
    }
  },
  watch: {
    // 红包雨倒计时结束
    'countDownTime' () {
      if (this.countDownTime === 0) {
        clearInterval(this.timerCountDown)
        this.initImages()
      }
    }
  },
  created () {
    this.startCountDownTime()
  },
  beforeDestroy () {
    if (this.timerCountDown) {
      clearInterval(this.timerCountDown)
      clearTimeout(this.timerRain)
    }
  },
  data () {
    return {
      showCountDownTime: false,
      countDownTime: 3,
      pointsNum: 0,
      timerCountDown: '',
      ctx: '',
      imagesList: [],
      sum: 20,
      canvas: {
        width: '',
        height: ''
      },
      count: null,
      animationId: '',
      touchePos: '',
      timerRain: '',
      timerPushRedPacket: '',
      popOpen: {
        title: '',
        content: '',
        imgUrl: ''
      },
      showPopDialog: false,
      showCountDown: false,
      showPrizePop: false
    }
  },
  methods: {
    // 下红包雨前倒计时 3s
    startCountDownTime () {
      this.showCountDownTime = true
      this.timerCountDown = setInterval(() => {
        this.showCountDownTime = !this.showCountDownTime
      }, 700)
    },
    // 淡入淡出效果结束调用
    afterLeave () {
      this.countDownTime--
    },
    initImages () {
      const RedPacketImg = new Image()
      RedPacketImg.src = require('../../../assets/images/redPacketRain/mobile/sport-packet.png')
      RedPacketImg.onload = () => {
        this.initCanvas()
        this.timerPushRedPacket = setInterval(() => {
          this.imagesList.push(this.initImageItem(RedPacketImg))
          if (!this.count) {
            this.count = true
            this.drawImages()
          }
        }, 200)
        // 计时器红包雨持续时间10s
        this.timerRain = setTimeout(() => {
          this.stopRedPacketRain()
        }, 1000 * 10)
      }
    },
    // 初始化canvas 监听点击事件
    initCanvas () {
      const canvas = document.getElementById('canvas')
      canvas.addEventListener('touchstart', event => {
        this.touchePos = {
          x: event.touches[0].clientX,
          y: event.touches[0].clientY
        }
        this.handleClickRedPacket()
      })
      this.canvas.width = canvas.width = window.innerWidth
      this.canvas.height = canvas.height = window.innerHeight
      if (canvas.getContext) {
        this.ctx = canvas.getContext('2d')
      }
    },
    // 生成随机红包图片
    initImageItem (image) {
      return {
        image,
        x: parseInt(Math.random() * this.canvas.width - 50), // 图片右下角x坐标
        y: parseInt(Math.random() * -30), // 图片右下角y坐标
        speed: parseInt(Math.random() * 2 + 7), // 下落速度
        width: 100, // 图片宽度
        height: 112 // 图片高度
      }
    },
    // 绘制动画
    drawImages () {
      // 屏幕尺寸改变时重新初始化canvas
      if (this.canvas.width !== window.innerWidth || this.canvas.height !== window.innerHeight) {
        this.initCanvas()
      }
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
      this.imagesList.forEach((item, index) => {
        this.ctx.drawImage(item.image, item.x, item.y += item.speed, item.width, item.height)
        // 如果下落到超出canvas范围 则删除该红包
        if (item.y > this.canvas.height) {
          this.imagesList.splice(index, 1)
        }
      })
      this.animationId = window.requestAnimationFrame(this.drawImages)
    },
    handleClickRedPacket () {
      for (let i = 0; i < this.imagesList.length; i++) {
        const img = this.imagesList[i]
        // 红包图片x坐标范围
        const imgRangeX = {
          min: img.x,
          max: img.x + img.width
        }
        // 红包图片y坐标范围
        const imgRangeY = {
          min: img.y,
          max: img.y + img.height
        }
        const touchX = this.touchePos.x
        const touchY = this.touchePos.y
        // 判断点击的坐标是否落在红包图片坐标范围内
        if (touchX > imgRangeX.min && touchX < imgRangeX.max && touchY > imgRangeY.min && touchY < imgRangeY.max) {
          this.imagesList.splice(i, 1)
          this.pointsNum++
          return
        }
      }
    },
    // 倒计时结束关闭红包雨
    stopRedPacketRain () {
      console.log('动画关闭')
      // 停止往数组添加红包
      clearInterval(this.timerPushRedPacket)
      // 关闭动画
      window.cancelAnimationFrame(this.animationId)
      // 清除画布
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
      this.showPopDialog = true
    },
    // 开红包
    openRedPacket () {
      console.log('开红包')
      const currentTime = new Date().getTime()
      // 判断开红包的时间，是否在红包雨时间段
      if (currentTime >= this.currentActivityStartTime && currentTime <= this.currentActivityEndTime && this.pointsNum) {
        // 判断是否有点中红包
        activityApi.getPrizeInfo().then(response => {
          if (response.data.resultCode === '0') {
            this.showPopDialog = false
            this.showPrizePop = true
            // 根据后端参数判断有无中奖
            if (response.data.resultData.redBag) {
              const prizeName = response.data.resultData.redBag.pointValue ? `${response.data.resultData.redBag.pointValue}积分` : response.data.resultData.redBag.itemName
              this.popOpen.imgUrl = require('../../../assets/images/redPacketRain/mobile/record.png')
              this.popOpen.title = `恭喜您获得<br/>${prizeName}`
              this.popOpen.content = '易加网恭祝您新年快乐'
            } else {
              this.popOpen.imgUrl = require('../../../assets/images/redPacketRain/mobile/sorry.png')
              this.popOpen.title = '很抱歉，未抢到红包'
              this.popOpen.content = '别灰心，下场再试试吧！'
            }
          }
        })
      } else {
        this.popOpen.imgUrl = require('../../../assets/images/redPacketRain/mobile/sorry.png')
        // 当前时间大于最后一场红包雨时间
        if (new Date().getTime() > this.activityTimeList[this.activityTimeList.length - 1].endDate) {
          this.popOpen.content = '别灰心，明年再来！'
        } else {
          this.popOpen.content = '别灰心，下场再试试吧！'
        }
        this.showPopDialog = false
        this.showPrizePop = true
        this.popOpen.title = '很抱歉，未抢到红包'
      }
    },
    handleClosePop () {
      this.showPopDialog = false
      this.$emit('handleClosePop')
    },
    handlePrizePop () {
      this.showPrizePop = false
      this.$emit('handleClosePop')
    }
  }
}
</script>

<style lang="less" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.pop {
  .pop-mark {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    background-color: rgba(0, 0, 0, .6);
    z-index: 3;
    .pop-time-count {
      line-height: calc(100vh);
      font-size: 180px;
      font-weight: 600;
      color:#f0f0f0;
    }
    .pop-dialog {
      padding: calc(20vh) calc(10vw) 0 calc(10vw);
      .pop-bg {
        z-index: 4;
        height: 350px;
        margin-bottom: 20px;
        text-align: center;
        background: url("../../../assets/images/redPacketRain/mobile/pop-bg.png") no-repeat;
        background-size: 100% 100%;
        .pop-text {
          padding-top: 10px;
          line-height: 30px;
          strong {
            font-size: 20px;
            font-weight: 500;
          }
          span {
            display: block;
            color: #999;
          }
        }
        .pop-open-packet {
          padding-top: 130px;
          img {
            max-width: 100px;
          }
        }
      }
    }
    .pop-btn-close {
      z-index: 4;
      text-align: center;
      img {
        max-width: 40px;
      }
    }
  }
}
</style>
